import axios from 'axios';

export const FAVORITE_JOBS_KEY = 'favoriteJobs';
export const FAVORITES_CHANGED_EVENT = 'favoriteJobsChanged';

export const getFavoriteJobIds = () => JSON.parse(localStorage.getItem(FAVORITE_JOBS_KEY)) || [];

const setFavoriteJobIds = (ids) => {
    localStorage.setItem(FAVORITE_JOBS_KEY, JSON.stringify(ids));
    window.dispatchEvent(new Event(FAVORITES_CHANGED_EVENT));
};

const addFavoriteBackend = (jobAdvertisementId) => {
    const url = global.backingsEndpoint + 'favoritesControl/addFavorite';

    return axios.post(url, {
        dto: {
            jobAdvertisementIdList: [jobAdvertisementId],
        },
    });
};

const removeFavoriteBackend = (jobAdvertisementId) => {
    const url = global.backingsEndpoint + 'favoritesControl/removeFavorite';

    return axios.post(url, {
        dto: {
            jobAdvertisementIdList: [jobAdvertisementId],
        },
    });
};

export const toggleFavoriteJob = async (jobAdvertisementId, loggedInFromFrontend = false) => {
    const savedFavorites = getFavoriteJobIds();
    const exists = savedFavorites.includes(jobAdvertisementId);

    const nextFavorites = exists
        ? savedFavorites.filter((id) => id !== jobAdvertisementId)
        : [...savedFavorites, jobAdvertisementId];

    setFavoriteJobIds(nextFavorites);

    if (loggedInFromFrontend) {
        if (exists) {
            await removeFavoriteBackend(jobAdvertisementId);
        } else {
            await addFavoriteBackend(jobAdvertisementId);
        }
    }

    return nextFavorites;
};

export const syncFavoriteJobsToBackend = async (loggedInFromFrontend = false) => {
    const savedFavorites = getFavoriteJobIds();

    if (!savedFavorites.length) return savedFavorites;
    if (!loggedInFromFrontend) return savedFavorites;

    const url = global.backingsEndpoint + 'favoritesControl/addFavorite';

    await axios.post(url, {
        dto: {
            jobAdvertisementIdList: savedFavorites,
        },
    });

    return savedFavorites;
};